import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    raReportsList: {
        data: [],
    },
    bdmReportsList: {  
        data: [],
    },
    recruiterReportsList: {
        data: [],
    },
    recruiterEmailDelivaryReportsList: {
        data: [],
    }
}

const reportsListSlice = createSlice({
    name: "reportList",
    initialState,
    reducers: {
        raReportsListStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        raReportsListSuccess: (state, action) => {
            state.loading = false;
            state.raReportsList.data = action.payload.data
        },
        raReportsListFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        bdmReportsListStart: (state) => {
            state.loading = true;
        },
        bdmReportsListSuccess: (state, action) => {
            state.loading = false;
            state.bdmReportsList.data = action.payload.data;
        },
        bdmReportsListFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        recruiterReportsListStart: (state) => {
            state.loading = true;
        },
        recruiterReportsListSuccess: (state, action) => {
            state.loading = false;
            state.recruiterReportsList.data = action.payload.data;
        },
        recruiterReportsListFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        recruiterEmailDelivaryReportsListStart: (state) => {
            state.loading = true;
        },
        recruiterEmailDelivaryReportsListSuccess: (state, action) => {
            state.loading = false;
            state.recruiterEmailDelivaryReportsList.data = action.payload.data;
        },
        recruiterEmailDelivaryReportsListFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        }
    }
});

export const {
    raReportsListStart,
    raReportsListSuccess,
    raReportsListFailure,
    bdmReportsListStart,
    bdmReportsListSuccess,
    bdmReportsListFailure,
    recruiterReportsListStart,
    recruiterReportsListSuccess,
    recruiterReportsListFailure,
    recruiterEmailDelivaryReportsListStart,
    recruiterEmailDelivaryReportsListSuccess,
    recruiterEmailDelivaryReportsListFailure,
} = reportsListSlice.actions;

export default reportsListSlice.reducer;